<script>
import { useLayoutStore } from "~/stores/layout";
import RightSideBar from "~/components/leyoutsCustomer/common/RightSideBar.vue";
import Footer from "~/components/leyoutsCustomer/common/Footer.vue";
import TopBar from "~/components/leyoutsCustomer/horizontal/TopBar.vue";
import SiteSearch from "~/components/search/SiteSearch.vue";

export default {
  created() {
    //document.body.setAttribute("data-layout", "horizontal");
   // document.body.setAttribute("data-topbar", "colored");
  },
  components: {
    TopBar,
    Footer,
    RightSideBar
  },
  methods: {
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
     document.body.classList.remove("right-bar-enabled");
    }
  },
  computed: {
    layout() {
      return useLayoutStore() ? useLayoutStore() : {};
    }
  }
};
</script>

<template>
  <div id="layout-wrapper" class="page-topbar-horizontal">
    <TopBar :type="layout.topbar" :width="layout.layoutWidth" />
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <SiteSearch placement="page" />
          <slot />
        </div>
      </div>
      <Footer />
    </div>
    <RightSideBar />
  </div>
</template>
